import { Show, SimpleShowLayout, TextField, ReferenceField, ArrayField, SingleFieldList, FunctionField, useRecordContext } from 'react-admin';
import { Chip } from '@mui/material';
import { personalityParameters } from  'skylar-agent/PromptCalc';
import PropTypes from 'prop-types';

const PersonalityConfigField = ({ source }) => {
	const record = useRecordContext();
	const personality = record[source];
	const fields = [];

	for ( const key in personalityParameters ) {
		const [ min, max ] = personalityParameters[key];
		const level = key in personality ? personality[key] : 5;

		if ( level != 5 ) {
			fields.push(<div>Score {level} where {min} is 1 and {max} is 9</div>);
		}
	}

	return <>
		{fields}
	</>;

};

PersonalityConfigField.propTypes = {
	source: PropTypes.string
};

const show = () => (
	<Show>
		<SimpleShowLayout>
			<TextField source="name" />
			<TextField source="description" />
			<ReferenceField source="voice_id" reference="voices">
				<TextField source="name" />
			</ReferenceField>
			<TextField source="character_details" />
			<PersonalityConfigField source="personality_config" />
			<ArrayField source="dialog_style">
				<SingleFieldList linkType={false}>
					<FunctionField render={item => <Chip label={item} />} />
				</SingleFieldList>
			</ArrayField>
		</SimpleShowLayout>
	</Show>
);

export default show;